/** Canvas discovery names stored content types before any database read. */
export const CONTEXT_CANVAS_TYPES = ["canvas", "idea", "web-page", "public-invitation"] as const;
export type ContextCanvasType = (typeof CONTEXT_CANVAS_TYPES)[number];
export function isContextCanvasType(value: unknown): value is ContextCanvasType {
  return typeof value === "string" && (CONTEXT_CANVAS_TYPES as readonly string[]).includes(value);
}
/**
 * Additional explicitly requested kinds, each with its own bounded reader
 * (CIO13, the principal 2026-09-08: an additional kind needs an explicit
 * product request and its own bounded reader). Mobile apps and CRM records
 * use their own World catalog readers. A named lens reads only its family;
 * the ordinary room catalog explicitly asks for all supported families.
 */
export const CONTEXT_OPERATIONAL_TYPES = ["mobile-app", "crm"] as const;
export const CONTEXT_CONTENT_TYPES = [
  ...CONTEXT_CANVAS_TYPES,
  ...CONTEXT_OPERATIONAL_TYPES,
] as const;
export type ContextContentType = (typeof CONTEXT_CONTENT_TYPES)[number];
export function isContextContentType(value: unknown): value is ContextContentType {
  return typeof value === "string" && (CONTEXT_CONTENT_TYPES as readonly string[]).includes(value);
}
/** Existing rail lens IDs are presentation aliases, not database record kinds.
 * Ordinary Desk discovery (no lens) names every family it intends to display:
 * the Canvas types and the World's mobile apps. A lens narrows to its own. */
export function contextCanvasTypes(lens?: string): readonly ContextContentType[] {
  if (lens === undefined) return CONTEXT_CONTENT_TYPES;
  if (lens === "canvas") return CONTEXT_CANVAS_TYPES;
  if (lens === "blueprint") return ["idea"];
  if (lens === "mobile-app") return ["mobile-app"];
  if (lens === "contacts" || lens === "crm") return ["crm"];
  return [];
}
